module.exports = __webpack_public_path__ + "img/Logo-light.0c24c1aa.svg";